"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var PlayerState_1 = __importStar(require("../constants/PlayerState"));

exports.RESET_TIMEOUT = 3000;

var createMouseHoverObservable = function createMouseHoverObservable(element, predicate) {
  var mouseMove$ = rxjs_1.fromEvent(element, 'mousemove').pipe(operators_1.filter(function (e) {
    return !e.defaultPrevented && (!predicate || predicate(e));
  }), operators_1.tap(function (e) {
    return e.preventDefault();
  }));
  var mouseLeave$ = rxjs_1.fromEvent(element, 'mouseleave').pipe(operators_1.filter(function (e) {
    return !e.defaultPrevented && (!predicate || predicate(e));
  }), operators_1.tap(function (e) {
    return e.preventDefault();
  }));
  return rxjs_1.merge(mouseMove$.pipe(operators_1.mapTo(true)), mouseLeave$.pipe(operators_1.mapTo(false))).pipe(operators_1.startWith(false));
};

var pointerTouchFilter = function pointerTouchFilter(e) {
  return e.pointerType === 'touch' || e.pointerType === 'pen';
};

var pointerMouseFilter = function pointerMouseFilter(e) {
  return e.pointerType === 'mouse';
};
/**
 * Used when pointer events are unavailable.
 */


var createPointerMoveDisabledObservable = function createPointerMoveDisabledObservable(rootContainer, bottomContainer, stateVisible$) {
  var isOnBottomContainer = function isOnBottomContainer(e) {
    return e.target === bottomContainer || bottomContainer.contains(e.target);
  };

  return rxjs_1.merge(createMouseHoverObservable(rootContainer, function (e) {
    return !isOnBottomContainer(e);
  }).pipe(operators_1.map(function (hover) {
    return {
      key: 'root',
      inputType: 'mouse',
      value: hover
    };
  })), createMouseHoverObservable(bottomContainer).pipe(operators_1.map(function (hover) {
    return {
      key: 'bottom',
      inputType: 'mouse',
      value: hover
    };
  }), operators_1.distinctUntilChanged()), rxjs_1.fromEvent(rootContainer, 'touchend').pipe(operators_1.filter(function (e) {
    return !e.defaultPrevented;
  }), operators_1.tap(function (e) {
    return e.preventDefault();
  }), operators_1.withLatestFrom(stateVisible$), operators_1.map(function (_a) {
    var e = _a[0],
        stateVisible = _a[1];
    return {
      key: 'root',
      inputType: 'touch',
      value: !stateVisible
    };
  })), rxjs_1.fromEvent(bottomContainer, 'touchend').pipe(operators_1.filter(function (e) {
    return !e.defaultPrevented;
  }), operators_1.tap(function (e) {
    return e.preventDefault();
  }), operators_1.map(function () {
    return {
      key: 'bottom',
      inputType: 'touch',
      value: true
    };
  })));
};

var createPointerMoveEnabledObservable = function createPointerMoveEnabledObservable(rootContainer, bottomContainer, stateVisible$) {
  return rxjs_1.merge(rxjs_1.fromEvent(rootContainer, 'pointermove').pipe(operators_1.filter(function (e) {
    return !e.defaultPrevented && pointerMouseFilter(e);
  }), operators_1.mapTo({
    key: 'root',
    inputType: 'mouse',
    value: true
  }), operators_1.startWith({
    key: 'root',
    inputType: 'mouse',
    value: false
  })), rxjs_1.fromEvent(rootContainer, 'pointerdown').pipe(operators_1.filter(function (e) {
    return !e.defaultPrevented && pointerTouchFilter(e);
  }), operators_1.withLatestFrom(stateVisible$), operators_1.map(function (_a) {
    var e = _a[0],
        stateVisible = _a[1];
    return {
      key: 'root',
      inputType: e.pointerType,
      value: !stateVisible
    };
  }), operators_1.startWith({
    key: 'root',
    inputType: 'touch',
    value: false
  })), rxjs_1.fromEvent(rootContainer, 'pointerleave').pipe(operators_1.filter(function (e) {
    return !e.defaultPrevented && pointerMouseFilter(e);
  }), operators_1.map(function (hover) {
    return {
      key: 'root',
      inputType: 'mouse',
      value: false
    };
  }), operators_1.startWith({
    key: 'root',
    inputType: 'mouse',
    value: false
  })), rxjs_1.merge(rxjs_1.fromEvent(bottomContainer, 'pointermove'), rxjs_1.fromEvent(bottomContainer, 'pointerdown')).pipe(operators_1.filter(function (e) {
    return !e.defaultPrevented;
  }), operators_1.tap(function (e) {
    return e.stopPropagation();
  }), operators_1.map(function (e) {
    return {
      key: 'bottom',
      inputType: e.pointerType,
      value: true
    };
  }), operators_1.startWith({
    key: 'bottom',
    inputType: 'touch',
    value: false
  })));
};
/**
 * Create an observable that is true while the component is hovered,
 * or hover-toggled for touch-devices.
 */


var createHoverObservable = function createHoverObservable(rootContainer, bottomContainer, stateVisible$, win) {
  if (win === void 0) {
    win = window;
  }

  return (win && typeof win.onpointermove === 'undefined' ? createPointerMoveDisabledObservable(rootContainer, bottomContainer, stateVisible$) : createPointerMoveEnabledObservable(rootContainer, bottomContainer, stateVisible$)).pipe(operators_1.switchMap(function (hover) {
    // Reset the observable (to false) if the mouse is not moved
    // while hovering the rootElement.
    return hover.value && hover.key === 'root' ? rxjs_1.merge(rxjs_1.of(true), rxjs_1.timer(exports.RESET_TIMEOUT).pipe(operators_1.mapTo(false))) : rxjs_1.of(hover.value);
  }), operators_1.startWith(false));
};
/**
 * Create an observable that is true while any node inside rootContainer is
 * in focus.
 */


var createFocusObservable = function createFocusObservable(rootContainer) {
  var focusIn$ = rxjs_1.fromEvent(rootContainer, 'focusin').pipe(operators_1.mapTo(true));
  var focusOut$ = rxjs_1.fromEvent(rootContainer, 'focusout').pipe(operators_1.filter(function (e) {
    // Ignore focusout events on child nodes of rootContainer
    return rootContainer.contains(e.relatedTarget) === false;
  }), operators_1.mapTo(false));
  return rxjs_1.merge(focusIn$, focusOut$).pipe(operators_1.startWith(false));
};
/**
 * Creates an observable that handles the UI visibility state.
 * It should be able to handle the following input types:
 *
 *  - Touch
 *  - Mouse
 *  - Pen
 *
 *  It should also be able to handle a switch between the different
 *  input types.
 *
 *
 *  TODO: This function is using preventDefault which can cause problems with other UI components
 *
 *
 * @param {HTMLElement} rootContainer The video player area
 * @param {HTMLElement} bottomContainer The video player controls area
 * @param {Observable<PlayerState>} playerState$ Current player state
 * @param {Observable<boolean>} stateVisible$ Current UI visibilty state
 * @param {Window} win May be mocked in test suite
 * @returns {Observable<boolean>}
 */


exports.createUiVisibilityObservable = function (rootContainer, bottomContainer, playerState$, stateVisible$, uiPosition$, loop$, win) {
  if (win === void 0) {
    win = window;
  }

  var hover$ = createHoverObservable(rootContainer, bottomContainer, stateVisible$, win);
  var focused$ = createFocusObservable(rootContainer);
  var uiPositionHasValue$ = uiPosition$.pipe(operators_1.distinctUntilChanged(), operators_1.map(function (value) {
    return value !== null;
  }), operators_1.startWith(false));
  var paused$ = rxjs_1.combineLatest(playerState$, loop$).pipe(operators_1.map(function (_a) {
    var playerState = _a[0],
        loop = _a[1]; // Do not flash UI visibility when video ends and video is looping.

    if (playerState === PlayerState_1["default"].ENDED && loop) {
      return false;
    }

    return PlayerState_1.isPaused(playerState);
  }));
  return rxjs_1.combineLatest(hover$, focused$, paused$, uiPositionHasValue$).pipe(operators_1.map(function (_a) {
    var hover = _a[0],
        focused = _a[1],
        paused = _a[2],
        uiPositionHasValue = _a[3];
    return hover || focused || paused || uiPositionHasValue;
  }), operators_1.distinctUntilChanged());
};

exports["default"] = exports.createUiVisibilityObservable;